"use strict";

exports.__esModule = true;
exports.TimelineSelector = TimelineSelector;
var _react = _interopRequireDefault(require("react"));
var _Selector = require("../../Core/Selector");
var _timelineDefinitions = require("../timelineDefinitions");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.name;
}
function renderItemText(input) {
  return input.label;
}
function itemPredicate(query, item) {
  var q = query.toLowerCase();
  return item.name.toLowerCase().indexOf(q) !== -1 || item.label.toLowerCase().indexOf(q) !== -1 || item.description.toLowerCase().indexOf(q) !== -1;
}

/**
 * Allows a user to select timeline(s) from a list.
 */
function TimelineSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      toggle: false,
      placeholder: props.multiple ? translate("TimelineSelector.placeholder.multiple", "Select Timelines") : translate("TimelineSelector.placeholder.single", "Select Timeline"),
      getKey: getKey,
      renderItemText: renderItemText,
      itemPredicate: itemPredicate,
      items: _timelineDefinitions.timelineDefinitions
    }, props));
  });
}